import { combineReducers } from 'redux';


import quotesReducer from './quotes/quotesReducers';
import capacityReducer from './capacity/capacityReducers';

import { quotesActionTriggers } from './quotes/quotesActions';
import { capacityActionTriggers } from './capacity/capacityActions';

import { QuotesStateModel } from './quotes/quotesStateModel';
import { CapacityStateModel } from './capacity/capacityStateModel';




export const reducers = combineReducers({
    quotesState: quotesReducer,
    capacityState: capacityReducer
});

export const actions = {
    quotes: {
        ...quotesActionTriggers
    },
    capacity: {
        ...capacityActionTriggers
    }
};

export interface StateModel {
    quotesState: QuotesStateModel;
    capacityState: CapacityStateModel;
};